import Grid, { GridSize } from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { kebabCase } from "lodash";

import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";
import { SpeechAudiometryReport } from "services/types/reports.type";
import { useGetUserQuery } from "services/users";

import { PreviewSpeechAudiometryDataGroup } from "./components";

interface PreviewSpeechWordRecognitionSpeechAudiometryProps {
  title: string;
  data?: SpeechAudiometryReport | null;
  detailSize?: GridSize;
  wordListSize?: GridSize;
  titleSize?: GridSize;
  pb?: number;
  titleMb?: number;
}

export default function PreviewSpeechWordRecognitionSpeechAudiometry({
  data,
  title,
  detailSize,
  wordListSize,
  titleSize,
  pb = 5,
  titleMb = 3
}: PreviewSpeechWordRecognitionSpeechAudiometryProps) {
  const { palette } = useTheme();
  const currentUser = useAppSelector(selectCurrentUser);
  const { data: user } = useGetUserQuery(currentUser.id, {
    skip: !currentUser.id || currentUser.id === -1
  });

  const switchAudiogramOrientation = Boolean(
    user?.user_preferences?.reporting?.switch_audiogram_orientation
  );
  return (
    <Grid
      item
      container
      spacing={0}
      marginTop={1}
      sx={{ pb }}
      data-testid={`subgroup-${kebabCase(title)}`}
    >
      {title && (
        <Grid item container lg={12} sx={{ mb: titleMb }}>
          <Typography
            fontSize={24}
            lineHeight="28px"
            color={palette.previewSpeechWordRecognition.color}
          >
            {title}
          </Typography>
        </Grid>
      )}
      {switchAudiogramOrientation ? (
        <PreviewSpeechAudiometryDataGroup
          data={data?.rightEar}
          title="Right"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      ) : (
        <PreviewSpeechAudiometryDataGroup
          data={data?.leftEar}
          title="Left"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      )}

      <PreviewSpeechAudiometryDataGroup
        data={data?.binaural}
        title="Binaural"
        detailSize={detailSize}
        wordListSize={wordListSize}
        titleSize={titleSize}
      />
      {switchAudiogramOrientation ? (
        <PreviewSpeechAudiometryDataGroup
          data={data?.leftEar}
          title="Left"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      ) : (
        <PreviewSpeechAudiometryDataGroup
          data={data?.rightEar}
          title="Right"
          detailSize={detailSize}
          wordListSize={wordListSize}
          titleSize={titleSize}
        />
      )}
    </Grid>
  );
}
